// import React, { useRef } from 'react'
// import { Button, Card, Col, Container, Row, Table } from 'react-bootstrap'
// import AdminHeader from './AdminHeader'
// import './AdminBilling.css'
// import html2pdf from 'html2pdf.js';
// import { saveAs } from 'file-saver';
// import { useReactToPrint } from 'react-to-print';

// const AdminBillPrint = () => {

//   // ---------------print-----
//   const componentRef = useRef();
//   const handlePrint = useReactToPrint({
//     content: () => componentRef.current,
//     documentTitle: 'Payment_Recipt',
//     // onAfterPrint: () => alert('Print Success')
//   })

//   const pdfOptions = {
//     margin: 10,
//     filename: 'Payment_Recipt.pdf',
//     image: { type: 'jpeg', quality: 0.98 },
//     html2canvas: { scale: 2 },
//     jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
//     pagebreak: { before: '.page-break' }, // Use this class to force page breaks
//   };

//   // Select the content to print (excluding buttons)
//   const contentToPrint = document.getElementById('content-to-print');

//   // Generate the PDF
//   html2pdf().from(contentToPrint).set(pdfOptions).outputPdf((pdf) => {
//     // Save the PDF to the user's PC
//     saveAs(pdf, 'Payment_Recipt.pdf');
//   });

//   return (
//     <Container >
//       {/* <Row>
//         <AdminHeader />
//       </Row> */}
//       <div ref={componentRef} id="content-to-print" style={{ width: "100%" }}>
//         <Row className='g-4 px-2 border m-0 p-0' style={{ display: "flex" }}>

//           <Col sm={12} md={6}>
//             <Card className='p-3' style={{ height: "378px" }}>
//               <Row className='text-center'>
//                 <Col>Gavali...</Col>
//               </Row>
//               <Row>
//                 <Col>Customer Name :</Col>
//               </Row>
//               <Row>
//                 <Col>Employee :</Col>
//               </Row>
//               <Row><Col>
//                 date from: 1-1-2024 ,  To : 31-1-2024
//               </Col></Row>

//               <Row className='m-0 p-0'>
//                 <Table striped bordered hover size='sm' className='shadow mt-2 ' style={{ textAlign: 'center', overflowX: 'auto' }}>
//                   <thead>
//                     <tr>
//                       <th style={{ alignItems: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif' }} className='text-center text-light'>
//                         Sr.No
//                       </th>
//                       <th style={{ alignItems: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif' }} className='text-center text-light'>
//                         Product
//                       </th>
//                       <th style={{ alignItems: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif' }} className='text-center text-light'>
//                         Quantity
//                       </th>
//                       <th style={{ alignItems: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif' }} className='text-center text-light'>
//                         Rate
//                       </th>
//                       <th style={{ alignItems: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif' }} className='text-center text-light'>
//                         Total
//                       </th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {/* {orderDataInner.map((item, index) => ( */}
//                     <tr className='border'
//                     //  key={index}
//                     >
//                       <td style={{ textAlign: 'center' }}>1</td>
//                       <td style={{ textAlign: 'center' }}>Milk</td>
//                       <td style={{ textAlign: 'center' }}>1</td>
//                       <td style={{ textAlign: 'center' }}>80</td>
//                       <td style={{ textAlign: 'center' }}>80</td>
//                     </tr>
//                     {/* ))} */}
//                   </tbody>
//                   <tfoot>
//                     <tr>
//                       <td style={{ textAlign: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif', color: 'white' }} colSpan="3"></td>
//                       <td style={{ textAlign: 'center', backgroundColor: 'darkslategray', fontSize: '15px', fontFamily: 'sans-serif', color: 'white' }}>
//                         Total Quantity: 200
//                         {/* {calculateTotalQuantity(orderDataInner)} */}
//                       </td>
//                       <td style={{ textAlign: 'center', backgroundColor: 'darkslategray', fontSize: '13px', fontFamily: 'sans-serif', color: 'white' }}>
//                         Grand total: 500
//                         {/* {calculateGrandTotal(orderData)} */}
//                       </td>

//                     </tr>
//                   </tfoot>
//                 </Table>
//               </Row>
//             </Card>
//           </Col>

//         </Row>
//       </div>

//       <Row className="mt-3">
//         <Col className="text-center">
//           <Button
//             className='py-2 px-3 mx-2 my-4 shadow text-dark print-button'
//             type='submit'
//             onClick={handlePrint}
//           >
//             Print
//           </Button>
//         </Col>
//       </Row>

//     </Container>
//   )
// }

// export default AdminBillPrint






import React, { useRef } from 'react'
import { Button, Card, Col, Container, Row, Table } from 'react-bootstrap'
import AdminHeader from './AdminHeader'
import './AdminBilling.css'
import html2pdf from 'html2pdf.js';
import { saveAs } from 'file-saver';
import { useReactToPrint } from 'react-to-print';

const AdminBillPrint = () => {

  const generatePDF = () => {
    // Get the element you want to convert to PDF
    const element = document.getElementById('pdf-content');
  
    // Options for the PDF generation
    const options = {
      margin: 7,
      filename: 'generated.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };
  
    // Call the html2pdf library
    html2pdf().set(options).from(element).toPdf().get('pdf').then(function (pdf) {
      // Generate a unique name for the PDF file
      const pdfName = `generated_${Date.now()}.pdf`;
  
      // Create a blob URL for the PDF
      const blobUrl = URL.createObjectURL(pdf.output('blob'));
  
      // Open the PDF in a new window or tab
      window.open(blobUrl, '_blank');
    });
  };
  

  return (
    <div>
       {/* <div >


            <div id="pdf-content" style={{ fontSize: "16px", fontFamily: "'Gotu', sans-serif", fontFamily: "'Noto Sans Devanagari', sans-serif" }}>
              <div className='row m-0 p-0'  >


                {data.map((item, index) => (
                  <div key={index} style={{ width: "382.4px", height: "547.01px", margin: "7.015px" }} className='border'>
                    <div className='text-center pt-3'>
                      <p>Gavali....</p>
                    </div>
                    <div className='row pt-3'>
                      <div className='text-start col-6'>
                        <p>Date : {item.bill_date}</p>
                      </div>
                      <div className='text-end col-6'>
                        <p>Bill no : {item.bill_no}</p>
                      </div>
                    </div>
                    <div>
                      <p>Cust. name : {item.customer_name}</p>
                    </div>
                    <div>
                      <p>Emp. name : {item.employee_name}</p>
                    </div>
                    <div>
                      <p>Month : {item.month} &nbsp; {item.year}</p>
                    </div>
                    <div>
                      <table id="pdf-table" style={{ borderCollapse: 'collapse', width: '100%' }}>
                        <thead style={{ fontSize: "12px" }}>
                          <tr>
                            <th style={{ border: '1px solid #dddddd', textAlign: 'center', padding: '8px' }}>Sr.No</th>
                            <th style={{ border: '1px solid #dddddd', textAlign: 'center', padding: '8px' }}>Product</th>
                            <th style={{ border: '1px solid #dddddd', textAlign: 'center', padding: '8px' }}>Qty</th>
                            <th style={{ border: '1px solid #dddddd', textAlign: 'center', padding: '8px' }}>Rate</th>
                            <th style={{ border: '1px solid #dddddd', textAlign: 'center', padding: '8px' }}>Total</th>
                          </tr>
                        </thead>
                        <tbody style={{ fontSize: "13px" }}>
                          {item.products.map((product, productIndex) => (
                            <tr key={productIndex}>
                              <td style={{ border: '1px solid #dddddd', textAlign: 'center', padding: '8px' }}>{productIndex + 1}</td>
                              <td style={{ border: '1px solid #dddddd', textAlign: 'center', padding: '8px' }}>{product.product}</td>
                              <td style={{ border: '1px solid #dddddd', textAlign: 'center', padding: '8px' }}>{product.quantity}</td>
                              <td style={{ border: '1px solid #dddddd', textAlign: 'center', padding: '8px' }}>{product.rate}</td>
                              <td style={{ border: '1px solid #dddddd', textAlign: 'center', padding: '8px' }}>{product.total}</td>
                            </tr>
                          ))}
                          <tr>
                            <td colSpan={3} style={{ border: '1px solid #dddddd', textAlign: 'end', padding: '8px' }}>Total Qty= {item.products.reduce((acc, cur) => acc + cur.quantity, 0)}</td>
                            <td colSpan={2} style={{ border: '1px solid #dddddd', textAlign: 'center', padding: '8px' }}>Net Amount = {item.products.reduce((acc, cur) => acc + cur.total, 0)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div className='row mt-5'>
                      <div className='col-9'>Last balance = {item.lastBalance}&nbsp;</div>
                      <div className='col-3'>Sign </div>
                    </div>
                  </div>
                ))}



               




              </div>


            </div>
          </div> */}
          </div>
  )
}

export default AdminBillPrint